export type CouponsBreadcrumbInput = {
  pathSegments: string[];
  segment: string;
  index: number;
  isLast: boolean;
  prefix: string;
  defaultTab?: string;
};

export type CouponsBreadcrumbResult = {
  skip: boolean;
  labelOverride?: string;
  pathOverride?: string;
};

export function handleCouponsBreadcrumb({
  pathSegments,
  segment,
  index,
  isLast,
  prefix
}: CouponsBreadcrumbInput): CouponsBreadcrumbResult {
  const hasCouponsAncestor = pathSegments.includes('coupons');
  if (!hasCouponsAncestor) {
    return { skip: false };
  }

  // Create flow: /coupons/form
  if (segment === 'form' && isLast) {
    return { skip: false, labelOverride: 'Create' };
  }

  // Edit flow: /coupons/form/:id or /coupons/:id
  const prev = pathSegments[index - 1];
  const isEdit =
    isLast && segment !== 'form' && (prev === 'form' || prev === 'coupons');
  if (segment === 'form' && !isLast) {
    // hide 'form' in edit flow
    return { skip: true };
  }
  if (isEdit) {
    return {
      skip: false,
      labelOverride: 'Edit',
      pathOverride: `${prefix}/coupons/${segment}`
    };
  }

  return { skip: false };
}
